export const omitKeys = <T, K extends keyof T>(object: T, omitKeys: K[]): Omit<T, K> => {
  const result = { ...object };

  for (const k of omitKeys) {
    delete result[k];
  }

  return result;
};
